import { Link, useLocation } from "react-router-dom";
import AuthStore from "../../stores/AuthStore";
import { observer } from "mobx-react";
import { Button } from "../ui/button";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from "../ui/navigation-menu";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { Rocket } from "lucide-react";

export const NavbarLandingPage = observer(() => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const currentLang = i18n.language || "en";

  const handleLanguageChange = (lang) => {
    if (lang !== currentLang) {
      i18n.changeLanguage(lang);
    }
  };

  const navItems = [
    { labelKey: "nav.home", path: "/" },
    { labelKey: "nav.pricing", path: "/pricing" },
    { labelKey: "nav.about", path: "/about" },
  ];

  return (
    <nav className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link className="flex items-center gap-2 font-bold text-xl" to="/">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center text-white">
              <Rocket className="h-5 w-5" />
            </div>
            <span>Rituely</span>
          </Link>

          <NavigationMenu className="hidden md:flex">
            <NavigationMenuList>
              {navItems.map((item) => (
                <NavigationMenuItem key={item.path}>
                  <Link to={item.path} legacyBehavior passHref>
                    <NavigationMenuLink
                      className={cn(
                        navigationMenuTriggerStyle(),
                        location.pathname === item.path &&
                          "bg-accent text-accent-foreground"
                      )}
                    >
                      {t(item.labelKey)}
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
              ))}
            </NavigationMenuList>
          </NavigationMenu>

          <div className="flex items-center space-x-4">
            {/* Language Switcher */}
            <div className="hidden sm:flex items-center gap-1">
              <Button
                variant={currentLang.startsWith("en") ? "default" : "outline"}
                size="sm"
                className="h-8 px-2 text-xs"
                onClick={() => handleLanguageChange("en")}
              >
                EN
              </Button>
              <Button
                variant={currentLang.startsWith("tr") ? "default" : "outline"}
                size="sm"
                className="h-8 px-2 text-xs"
                onClick={() => handleLanguageChange("tr")}
              >
                TR
              </Button>
            </div>

            {AuthStore.isLogin || AuthStore.isHaveTokenLogin() ? (
              <Button asChild variant="default">
                <Link to="/dashboard">{t("nav.goToDashboard")}</Link>
              </Button>
            ) : (
              <>
                <Button asChild variant="ghost">
                  <Link to="/login">{t("nav.login")}</Link>
                </Button>
                <Button asChild variant="default">
                  <Link to="/register">{t("nav.register")}</Link>
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
});
